import { usePushSubscription } from 'server';

/**
 * Event fires when Verification email push is received
 * @memberOf Playtech.API.events
 * @event verification-message-success-push
 * @event verification-message-fail-push
 * @example Playtech.on('verification-message-success-push', () => {
 *     // ...
 * });
 */
export const VERIFICATION_MESSAGE_SUCCESS = 'verification-message-success-push';
export const VERIFICATION_MESSAGE_FAIL = 'verification-message-fail-push';

export const useOnVerificationEmail = (eventTarget) => {
    usePushSubscription([
        35557, 35558
    ], () => pushMessage => {
        const eventName = pushMessage.ID === 35557
            ? VERIFICATION_MESSAGE_SUCCESS
            : VERIFICATION_MESSAGE_FAIL;

        const event = new CustomEvent(eventName);

        eventTarget.dispatchEvent(event);
    });
};
